import warningSvg from 'assets/images/icons/warning-triangle.svg';
import {Divider, Stack, Typography} from '@mui/material';
import {SVGIcon} from '@resurs-internal/mui';
import {useFeatureFlags, useTranslate} from 'hooks';

export const OfferLegalWarning = ({
  showLegalWarning = true,
}: {
  showLegalWarning?: boolean;
}) => {
  const translate = useTranslate();
  const flags = useFeatureFlags();
  if (!flags.offerLegalWarning) return null;
  if (!showLegalWarning) return null;
  return (
    <Stack style={{marginTop: 4}} gap={2}>
      <Divider />
      <Stack direction="row" gap={2}>
        <SVGIcon
          name={warningSvg}
          alt={translate('common.warning')}
          size={88}
        />
        <Stack>
          <Typography variant={'subtitle1'}>
            {translate('offers.legal.title')}
          </Typography>
          <Typography
            role="button"
            variant={'body1'}
            style={{cursor: 'pointer'}}
            onClick={() =>
              window.open(translate('offers.legal.link'), '_blank')
            }>
            {translate('offers.legal.subtile')}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
